<template>
  <div class="container-fluid py-3">
    <h1>Списки чеков</h1>
    <ul class="nav nav-tabs mb-3">
      <li v-for="tab in tabs" :key="tab.type" class="nav-item">
        <a href="#" :class="['nav-link', {active: type === tab.type}]" @click.prevent="selectType(tab.type)">{{ tab.label }}</a>
      </li>
    </ul>

    <div class="card mb-4">
      <div class="card-body">
        <div class="d-flex flex-wrap mb-3">
          <span v-for="item in values" :key="item.value" class="reference-tag">
            {{ item.label || item.value }}<small v-if="item.label && item.label !== item.value" class="ml-1">({{ item.value }})</small>
            <button type="button" class="reference-remove" :disabled="saving" @click="remove(item.value)">&times;</button>
          </span>
        </div>
        <div class="form-row">
          <div class="col-md-5"><input v-model.trim="form.value" class="form-control" placeholder="Значение" @keyup.enter="add"></div>
          <div class="col-md-5"><input v-model.trim="form.label" class="form-control" placeholder="Подпись (необязательно)" @keyup.enter="add"></div>
          <div class="col-md-2"><button class="btn btn-primary btn-block" :disabled="saving || !form.value" @click="add">Добавить</button></div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between"><span>История изменений</span><select v-model.number="perPage" class="custom-select custom-select-sm page-size" @change="load(1)"><option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option></select></div>
      <el-table :data="logs.data || []" stripe>
        <el-table-column prop="created_at" label="Дата" min-width="170"/>
        <el-table-column prop="value" label="Значение"/>
        <el-table-column prop="label" label="Подпись"/>
        <el-table-column prop="action" label="Действие"/>
        <el-table-column prop="user_email" label="Пользователь"/>
      </el-table>
      <div v-if="logs.total" class="d-flex justify-content-between p-3"><span>Всего: {{ logs.total }}</span><div class="btn-group"><button class="btn btn-outline-secondary btn-sm" :disabled="logs.current_page <= 1" @click="load(logs.current_page - 1)">Назад</button><span class="btn btn-light btn-sm disabled">{{ logs.current_page }} / {{ logs.last_page }}</span><button class="btn btn-outline-secondary btn-sm" :disabled="logs.current_page >= logs.last_page" @click="load(logs.current_page + 1)">Вперёд</button></div></div>
    </div>
  </div>
</template>

<script>
  import api from '../../api'
  export default {
    metaInfo: {title: 'Списки чеков'},
    data () { return {tabs: [{type: 'kkt', label: 'ККТ'}, {type: 'payment_type', label: 'Типы оплаты'}, {type: 'status', label: 'Статусы оплаты'}], type: 'kkt', values: [], logs: {}, pageSizes: [25, 50, 100, 500, 1000], perPage: 25, saving: false, form: {value: '', label: ''}} },
    created () { this.load(1) },
    methods: {
      selectType (type) { this.type = type; this.form = {value: '', label: ''}; this.load(1) },
      load (page) { return api.get('receipt-reference-values', {params: {type: this.type, page, per_page: this.perPage}}).then(({data}) => { this.values = data.values; this.logs = data.logs; this.pageSizes = data.page_sizes }) },
      add () { if (!this.form.value || this.saving) return; this.save(api.post('receipt-reference-values', {type: this.type, value: this.form.value, label: this.form.label})) },
      remove (value) { if (!this.saving) this.save(api.delete(`receipt-reference-values/${this.type}/${encodeURIComponent(value)}`)) },
      save (request) { this.saving = true; request.then(() => { this.form = {value: '', label: ''}; return this.load(1) }).catch(() => this.$root.showAlert('Не удалось сохранить изменение')).finally(() => { this.saving = false }) },
    },
  }
</script>

<style scoped>
  .reference-tag { display: inline-flex; align-items: center; margin: 0 0.5rem 0.5rem 0; padding: 0.35rem 0.4rem 0.35rem 0.65rem; border: 1px solid #b8d8e8; border-radius: 0.25rem; background: #eef7fb; color: #27647f; }
  .reference-remove { border: 0; background: transparent; color: #6c9caf; cursor: pointer; font-size: 1rem; }
  .page-size { width: 100px; }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/receipt-lists.vue